<script>

import VueQr from 'vue-qr'

export default {
  name: 'CouponQrcode',
  components: { VueQr },
  data(){
    return {

    }
  },
  computed:{
    url(){
      return this.$bus.getUrl(2)
    }
  }
}
</script>

<template>
  <div class="text-center">
    <vue-qr
        ref="qr"
        :text="url"
        :margin="10"
        :size="600"
        style="width: 100px; height: 100px"
        :logoScale="0.25"
    />
  </div>
</template>

<style scoped lang="scss">

</style>